import { useSelector } from 'react-redux';

export const configSelector = (state) => state?.toJS().config;

export const useStateConfig = () => useSelector(configSelector) || {};
